/**
 * Validation result for group data
 */
export type GroupValidationResult = {
  isValid: boolean;
  errors: {
    name?: boolean;
    description?: boolean;
  };
};

/**
 * Validates group name
 * @param name - Group name to validate
 * @returns True if valid, false otherwise
 */
export function validateGroupName(name: string | null | undefined): boolean {
  return !!(name && name.length > 1 && name.length <= 100);
}

/**
 * Validates group description
 * @param description - Group description to validate
 * @returns True if valid, false otherwise
 */
export function validateGroupDescription(
  description: string | null | undefined,
): boolean {
  if (!description) {
    return true; // Description is optional
  }
  return description.length < 500;
}

/**
 * Validates all group data
 * @param name - Group name
 * @param description - Group description
 * @returns Validation result with errors
 */
export function validateGroupData(
  name: string | null | undefined,
  description: string | null | undefined,
): GroupValidationResult {
  const errors = {
    name: !validateGroupName(name),
    description: !validateGroupDescription(description),
  };

  const isValid = !Object.values(errors).some((error) => error === true);

  return {
    isValid,
    errors,
  };
}

/**
 * Validates file size
 * @param file - File to validate
 * @param maxSizeMB - Maximum file size in MB
 * @returns True if valid, false otherwise
 */
export function validateFileSize(file: File, maxSizeMB: number): boolean {
  const fileSizeMB = file.size / 1024 / 1024;
  return fileSizeMB < maxSizeMB;
}
